<div class="trigger"> 
  <div class="popup">
    <div class="inner">
      <div class="col-12 d-flex px-2 message-header">
        <div class="col-10">
          {{label.headerlabel | translate}}
          {{helplabel.label[label]}}
        </div>
        <div class="col-2 text-right">
          <img [src]="closeicon" (click)="onClose()" class="closeicon" alt="Close Icon">
        </div>
      </div>
      <div class="message-body pt-2 pb-1 px-2 pr-3">
      <div class="col-12">
        <u><p class="message">{{helplabel.label[label.discriptio]}}</p></u>
      </div>
    </div>
    </div>
  </div>
</div>
